<div class="content-with-filled-button">
    <div class="main">
        <h1 class="sub-title" id="generalTitle">
            {{ copyService.copies.foreign_products_title }}
        </h1>
        <div class="content-checkbox">
            <voxel-radio-button-group id="radioLiveAbroad">
                <voxel-radio-button *ngFor="let radioButton of listradioSelectedForeign" [id]="radioButton.elementId" [checked]="radioButton.checked" (radioButtonChange)="selectradioSelectedForeign(radioButton)" [value]="radioButton.value">
                    {{radioButton.label}}
                </voxel-radio-button>
            </voxel-radio-button-group>
        </div>
    </div>
</div>
<app-controls id="foreignProductsBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.form_goods_button" [nextDisabled]="false" (next)="next()"></app-controls>